import React from 'react';
import { DotmSquare7 } from './ui/dotm-square-7';
import { DotmSquare8 } from './ui/dotm-square-8';

interface LoadingIndicatorProps {
    label?: string;
    compact?: boolean;
}

const DotMatrixLoader = Math.random() < 0.5 ? DotmSquare7 : DotmSquare8;

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ label, compact = false }) => (
    <div className={`flex items-center justify-center gap-3 text-white/70 ${compact ? '' : 'py-10'}`}>
        <DotMatrixLoader
            size={compact ? 22 : 38}
            dotSize={compact ? 3 : 5}
            className="text-white"
            aria-label={label || 'Betöltés'}
        />
        {label && (
            <span className="text-sm font-medium tracking-wide text-white/60">
                {label}
            </span>
        )}
    </div>
);

export default LoadingIndicator;
